import {Component, computed, signal, OnDestroy} from '@angular/core';
import {UserDetailsStore} from '@stores/user-details.store';
import {UserStore} from '@stores/user.store';
import {buildLicenseLogos} from '@utils/user-details-utils';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'cloudlab-complete-profile-step3',
  templateUrl: './cloudlab-complete-profile-step3.component.html',
  styleUrls: ['./cloudlab-complete-profile-step.component.scss'],
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
})
export class CloudlabCompleteProfileStep3Component implements OnDestroy {
  sensorOptions = [
    {key: 'voyager', label: 'complete-profile.voyager'},
    {key: 'weather', label: 'complete-profile.weather'},
    {key: 'air', label: 'complete-profile.air'},
    {key: 'gForce', label: 'complete-profile.gForce'},
    {key: 'odyssey', label: 'complete-profile.odyssey'},
    {key: 'thermo', label: 'complete-profile.thermo'},
  ];

  selectedSensors = signal<string[]>([]);
  premiumContentImages = signal<{src: string; alt: string}[]>([]);

  constructor(
    private userDetailsStore: UserDetailsStore,
    private userStore: UserStore,
  ) {
    this.premiumContentImages.set(
      buildLicenseLogos(this.userStore.state()?.curriculums),
    );

    const details = this.userDetailsStore.state();
    this.selectedSensors.set([...(details.sensors || [])]);
  }

  ngOnDestroy() {
    this.saveToStore();
  }

  toggleSensor(key: string) {
    this.selectedSensors.update((sensors) => {
      const index = sensors.indexOf(key);
      return index >= 0
        ? sensors.filter((_, i) => i !== index)
        : [...sensors, key];
    });
    this.saveToStore();
  }

  isSensorSelected(key: string): boolean {
    return this.selectedSensors().includes(key);
  }

  saveToStore() {
    this.userDetailsStore.setDoneness(true);
    this.userDetailsStore.setSensors([...this.selectedSensors()]);
  }
}
